// const Terms = () => {
//   return (
//     <main className="min-h-screen bg-surface">
//       {/* SEO Header */}
//       <header className="max-w-4xl mx-auto px-4 pt-12 text-center">
//         <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary">
//           Terms & Conditions
//         </h1>
//         <p className="mt-3 text-sm text-textSecondary">
//           Please read these terms and conditions carefully before using our services.
//         </p>
//       </header>

//       {/* Content Card */}
//       <section
//         className="mt-8 max-w-4xl mx-auto bg-white rounded-2xl shadow-md
//                    px-6 py-8 sm:px-8"
//         aria-labelledby="terms-content"
//       >
//         <article
//           id="terms-content"
//           className="prose prose-sm sm:prose max-w-none
//                      prose-headings:text-textPrimary
//                      prose-p:text-textSecondary
//                      prose-li:text-textSecondary"
//         >
//           <h2>1. Acceptance of Terms</h2>
//           <p>
//             By accessing or using our website and services, you agree to be bound
//             by these Terms and Conditions. If you do not agree with any part of
//             these terms, you must not use our services.
//           </p>

//           <h2>2. Services</h2>
//           <p>
//             We provide online learning services including live sessions, group
//             classes, and one-on-one instruction. All sessions are subject to
//             availability and scheduling policies.
//           </p>

//           <h2>3. User Responsibilities</h2>
//           <ul>
//             <li>Provide accurate and up-to-date personal information</li>
//             <li>Maintain the confidentiality of your account credentials</li>
//             <li>Use the platform only for lawful purposes</li>
//           </ul>

//           <h2>4. Payments & Refunds</h2>
//           <p>
//             All payments must be completed in advance. Refund eligibility, if
//             applicable, will follow our refund policy shared at the time of
//             purchase.
//           </p>

//           <h2>5. Intellectual Property</h2>
//           <p>
//             All content, materials, and branding on this website are the
//             intellectual property of the company and may not be reused,
//             reproduced, or distributed without written permission.
//           </p>

//           <h2>6. Limitation of Liability</h2>
//           <p>
//             We shall not be held responsible for any indirect, incidental, or
//             consequential damages arising from the use of our services.
//           </p>

//           <h2>7. Termination</h2>
//           <p>
//             We reserve the right to suspend or terminate access to our services
//             if a user violates these Terms and Conditions.
//           </p>

//           <h2>8. Changes to Terms</h2>
//           <p>
//             We may update these Terms and Conditions from time to time. Continued
//             use of the services after changes are posted constitutes acceptance
//             of the revised terms.
//           </p>

//           <h2>9. Contact Information</h2>
//           <p>
//             If you have any questions about these Terms and Conditions, please
//             contact us through our official support channels.
//           </p>
//         </article>
//       </section>
//     </main>
   
//   );
// };

// export default Terms;

import { useEffect, useState } from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

const Terms=() => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/templates/term.txt")
      .then((res) => res.text())
      .then((html) => {
        const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
        setContent(clean);
      })
      .catch(() => setContent("<p>Unable to load privacy policy.</p>"));
  }, []);

  return (
    <main className="min-h-screen bg-surface px-4 py-12">
      {/* Header */}
      <header className="max-w-4xl mx-auto text-center mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-2">
         Terms & Conditions
        </h1>
        <p className="text-sm text-textSecondary">
          Please read these terms and conditions carefully before using our services.
        </p>
      </header>

      {/* Content */}
      <section className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-6 sm:p-8">
        <article className="prose max-w-none
                             prose-headings:text-textPrimary
                             prose-p:text-textSecondary
                             prose-li:text-textSecondary
                             prose-a:text-primary
                             prose-a:hover:text-primary-light">
          {parse(content)}
        </article>
      </section>
    </main>
  );
}
export default Terms; 
